import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseSiteService,
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  RoutingService,
} from '@spartacus/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { CustomProdPgService } from 'src/app/custom-prod-pg/custom-prod-pg.service';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import * as _ from 'underscore';
import { CustomAddToCartService } from '../custom-add-to-cart.service';
import { ProductDetailsComponent } from '../custom-add-to-cart/product-details/product-details.component';

@Component({
  selector: 'app-schedule-futureship-cart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './schedule-futureship-cart.component.html',
  styleUrls: ['./schedule-futureship-cart.component.scss'],
})
export class ScheduleFutureshipCartComponent implements OnInit, OnDestroy {
  defaultImg = '';
  deliveryDate = moment().format('MM/DD/YYYY');
  baseUrl = this.occEndPoint.getBaseUrl({
    baseUrl: true,
    prefix: false,
    baseSite: false,
  });
  showUnits = false;
  isShowDeliveryHours = false;
  isUnitSelected = false;
  isSticky = false;
  isCartSticky = false;
  weekList = [];
  futureshipProdLists = [];
  productList = [];
  cartIdSub: Subscription;
  cartItemsSub: Subscription;
  checkoutCartDetailsSub: Subscription;
  cartCheckSub: Subscription;
  originalUnitsVal: any;
  originalDosesVal: any;
  originalFutureShipLists = [];
  totalFutureUnits: any;
  totalFutureDoses: any;
  quantityList = [];
  schedulerStatus = 'Remaining to schedule';
  productDeliveryDate = moment().format('MM/DD/YYYY');
  parentCartId = '';
  childCartId = '';
  b2bUnitId = '';
  deliveryHours: [];
  tempDeliveryDate = moment().format('MM/DD/YYYY');
  shipImmediateValue = {};
  baseSiteId = '';
  disabledDates = [];
  minDate: any;
  maxDate: any;
  schedulerContent = '';
  isPopoverClosed = false;
  shipLocation = '';
  shipLocationId = '';
  exportExcelData = [];
  selectedProduct: any;
  panelProductExpanded: boolean;
  panelProductExpanded2 = false;
  gallery: any[];
  monograph: any;
  quantityUpdateArray = [];
  getFutureCartSub: Subscription;
  weekObj = {};
  isMobileView = false;
  shippingInfo: any;
  shipDate: any;
  shipDateForNonFS: any;
  headerDeliveryDate;
  headerShipDate;
  fluProducts = [];
  fluDisabledDates = [];
  fluDeliveryDate = moment().format('MM/DD/YYYY');
  fluShippingInfo = [];

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    if (window.pageYOffset >= 350) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
    if (window.pageYOffset >= 450) {
      this.isCartSticky = true;
    } else {
      this.isCartSticky = false;
    }
  }

  constructor(
    private readonly occEndPoint: OccEndpointsService,
    private readonly sharedService: SharedService,
    private readonly plpService: CustomProdPgService,
    private readonly addToCart: CustomAddToCartService,
    private readonly cd: ChangeDetectorRef,
    private readonly route: RoutingService,
    private readonly modalService: NgbModal,
    private readonly pfService: CustomProfileAndPreferencesService,
    private baseSiteService: BaseSiteService,
    private globalMessage: GlobalMessageService,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.productList = [];
    let userId = this.sharedService.getLocalStorage('userId');
    this.b2bUnitId = this.sharedService.getLocalStorage('accountId');
    this.plpService.getCarts(userId);
    this.cartIdSub = this.plpService.cartItems$.subscribe((res) => {
      if (res) {
        let cartItems = res?.carts;
        this.addToCart.getCarts(cartItems?.code, userId);
        this.cartItemsSub = this.addToCart.cartItems$.subscribe((res: any) => {
          if (res) {
            const params = {
              b2bUnitId: this.b2bUnitId,
            };
            this.cartCheckSub = this.addToCart
              .cartCheck(res?.code, userId, params)
              .subscribe((cartData) => {
                this.parentCartId = cartData.carts[0].code;
                cartData.carts[0]?.childCarts.forEach((childCart) => {
                  if (childCart.cartType == 'STANDARD') {
                    this.futureshipProdLists = childCart?.entries.filter(
                      (x) => x.futureShipExpProd === true
                    );
                    const tempList = childCart.entries.filter(
                      (x) => x.futureShipExpProd === false
                    );
                    this.childCartId = childCart.code;
                    if (tempList.length > 0) {
                      this.productList.push({
                        entries: tempList,
                        cartType: 'STANDARD',
                        cartId: childCart.code,
                      });
                      this.setMinMaxDeliveryDate(childCart, 'STANDARD');
                    } else {
                      this.setMinMaxDeliveryDate(childCart, '');
                    }
                  } else if (childCart.cartType == 'INFLUENZA') {
                    this.productList.push({
                      entries: childCart.entries,
                      cartType: 'INFLUENZA',
                      cartId: childCart.code,
                    });
                    this.setMinMaxDeliveryDate(childCart, 'INFLUENZA');
                  }
                });
                this.futureshipProdLists?.map((c) => {
                  c['childCartId'] = this.childCartId;
                  c.shipNow = false;
                });
                this.quantityList = [];
                this.futureshipProdLists.forEach((element) => {
                  element.cartStatus = 'Remaining to Schedule';
                  element.exceeds = false;
                  let codeObj = {};
                  codeObj[element.product.code] = [];
                  this.quantityList.push(codeObj);
                });
                this.originalFutureShipLists = this.futureshipProdLists?.map(
                  (item) => ({
                    code: item.product.code,
                    quantity: item.quantity,
                    quantityPerUnit: item.product.quantityPerUnit,
                  })
                );
                this.totalFutureUnits = this.futureshipProdLists
                  ?.map((t) => t?.quantity)
                  ?.reduce((prev, next) => prev + next);
                this.originalUnitsVal = this.totalFutureUnits;
                let calVal = 0;
                this.futureshipProdLists.forEach((item) => {
                  calVal +=
                    Number(item['quantity']) *
                    Number(item.product['quantityPerUnit']);
                });
                this.totalFutureDoses = calVal;
                this.originalDosesVal = calVal;
                this.shipLocation =
                  cartData.carts[0].childCarts[0]?.shipToLoc_name;
                this.shipLocationId =
                  cartData.carts[0].childCarts[0]?.shipToLoc_id;
                this.addValuesToExcelData();
                let shipNowProducts = [];
                shipNowProducts = JSON.parse(
                  this.sharedService.getLocalStorage('shipNowProducts')
                );
                if (shipNowProducts) {
                  shipNowProducts?.forEach((item) => {
                    this.futureshipProdLists
                      .filter((x) => x.product.code === item)
                      .map((c) => {
                        c.shipNow = true;
                      });
                  });
                }
                this.weekList = [];
                this.getWeeksList();
                this.updateExistingUnit();
                this.cd.detectChanges();
              });
          }
          this.cd.detectChanges();
        });
      }
    });

    //get delivery hours
    this.pfService.getUserAccountDetailsDataFromDb(userId, this.b2bUnitId);
    this.pfService.userAccountDetails.subscribe((data: any) => {
      this.deliveryHours = data.res?.customerSalesAreaData?.deliveryHours;
    });

    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => {
        this.baseSiteId = res;
        this.defaultImg = `../../../assets/icons/${this.baseSiteId}/sanofi_missing_product.jpg`;
      });
    this.showUnits = true;
    this.schedulerContent =
      this.sharedService.getLocalStorage('schedulerContent');

    //mobile view
    this.isMobileView = window.innerWidth <= 768;
    window.addEventListener('resize',this.reSizeEvent, true);
  }
  reSizeEvent(event:any) : void {
    this.isMobileView = window.innerWidth <= 768;
  }
  getWeeksList() {
    //get difference b/w the two dates in months
    const diff = Math.floor(
      moment(this.sharedService.getLocalStorage('futureShippingEndDate')).diff(
        moment(this.sharedService.getLocalStorage('futureShipStartDate')),
        'months',
        true
      )
    );

    let fSStartDateMonth = new Date(
      this.sharedService.getLocalStorage('futureShipStartDate')
    ).getMonth();
    let fSEndDateMonth = new Date(
      this.sharedService.getLocalStorage('futureShippingEndDate')
    ).getMonth();

    let selectedMonth = moment(
      this.sharedService.getLocalStorage('futureShipStartDate')
    ).month();
    let selectedYear = moment(
      this.sharedService.getLocalStorage('futureShipStartDate')
    ).year();

    for (let i = 0; i <= diff; i++) {
      const weekStartDates = this.getRemainingMondaysForMonth(
        selectedYear,
        selectedMonth,
        fSStartDateMonth,
        fSEndDateMonth
      );
      let temp = [],
        tempdate,
        tempDateValue,
        dateObj;
      weekStartDates.forEach((date) => {
        tempdate = date.format('MM/DD/YYYY');
        tempDateValue = date.format('YYYY-MM-DD');
        let tempWeek = 'Week of ' + tempdate;
        temp.push({ name: tempWeek, value: tempDateValue });
      });
      dateObj = {
        month: moment.months(selectedMonth),
        year: selectedYear,
        weeks: temp,
        showUnit: true,
      };
      this.weekList.push(dateObj);
      this.exportExcelData.push([dateObj.month + ` ` + dateObj.year]);
      this.exportExcelData.push(['Total Units/Doses', '']);
      selectedMonth == 11
        ? ((selectedMonth = 0), (selectedYear += 1))
        : (selectedMonth += 1);
    }
  }

  getRemainingMondaysForMonth(year, month, shipStartMonth, shipEndMonth) {
    const startOfMonth = moment({ year, month });

    const endOfMonth = startOfMonth.clone().endOf('month');

    const currentWeekday = startOfMonth.weekday();

    // Adjust startOfMonth to the next Monday if it's not already a Monday
    if (currentWeekday !== 1) {
      if (currentWeekday === 0) {
        startOfMonth.add(1, 'days');
      } else {
        startOfMonth.add(8 - currentWeekday, 'days');
      }
    }

    const remainingMondays = [];
    let currentMonday = startOfMonth.clone();

    let shipStartDate = new Date(
      this.sharedService.getLocalStorage('futureShipStartDate')
    ).getDate();

    let shipEndDate = new Date(
      this.sharedService.getLocalStorage('futureShippingEndDate')
    ).getDate();

    while (currentMonday.isSameOrBefore(endOfMonth)) {
      if (month == shipStartMonth) {
        if (shipStartDate <= currentMonday.clone().date()) {
          remainingMondays.push(currentMonday.clone());

          currentMonday.add(1, 'weeks');
        } else {
          currentMonday.add(1, 'weeks');
        }
      } else if (month == shipEndMonth) {
        if (shipEndDate >= currentMonday.clone().date()) {
          remainingMondays.push(currentMonday.clone());

          currentMonday.add(1, 'weeks');
        } else {
          currentMonday.add(1, 'weeks');
        }
      } else {
        remainingMondays.push(currentMonday.clone());
        currentMonday.add(1, 'weeks');
      }
    }

    return remainingMondays;
  }


  openCalendar(popover) {
    if (!this.isPopoverClosed) {
      this.isPopoverClosed = false;
      popover.open();
    } else {
      this.isPopoverClosed = false;
    }
  }

  performQuantityComputation(type, code, quantityPerUnit, weekItem): void {
    let minQUantity = 0,
      maximumQuantity = 9999;
    let unitCount = 0;
    const regex = new RegExp('^[0-9]{1,4}$', 'g');
    const inputElement = document.getElementById(
      `${type}` + `${code}`
    ) as HTMLInputElement;
    if (regex.test(inputElement.value) === true) {
      if (parseInt(inputElement.value, 10) >= maximumQuantity) {
        inputElement.textContent = maximumQuantity.toString();
      } else if (parseInt(inputElement.value, 10) <= minQUantity) {
        inputElement.textContent = minQUantity.toString();
      }
    }
    this.quantityList
      .filter((x) => x.hasOwnProperty(code))
      .map((t) => {
        let obj = {};
        obj[type + code] = inputElement.value == '' ? '0' : inputElement.value;
        let codeExisits = t[code].find((ele) =>
          ele.hasOwnProperty(type + code)
        );
        if (codeExisits) {
          t[code]
            .filter((ele) => ele.hasOwnProperty(type + code))
            .map((x) => {
              delete x.type + code;
              x[type + code] =
                inputElement.value == '' ? '0' : inputElement.value;
            });
        } else {
          t[code].push(obj);
        }

        t[code].forEach((element) => {
          for (let val in element) {
            unitCount += Number(element[val]);
          }
        });
      });
    let sumOfUnit = 0;
    this.quantityList.forEach((element, val) => {
      for (let val in element) {
        element[val].forEach((obj) => {
          for (let val in obj) {
            sumOfUnit += Number(obj[val]);
          }
        });
      }
    });
    if (Number(this.originalUnitsVal) < sumOfUnit) {
      this.totalFutureUnits = Number(sumOfUnit) - Number(this.originalUnitsVal);
      this.isUnitSelected = true;
      this.schedulerStatus = 'Exceeds Total';
    } else if (Number(this.originalUnitsVal) > sumOfUnit) {
      this.totalFutureUnits = Number(this.originalUnitsVal) - Number(sumOfUnit);
      this.isUnitSelected = true;
      this.schedulerStatus = 'Remaining to schedule';
    } else {
      this.totalFutureUnits = Number(this.originalUnitsVal);
      this.isUnitSelected = true;
      this.schedulerStatus = 'All units and doses have been scheduled';
    }

    //this.futureshipProdLists =
    this.futureshipProdLists
      .filter((x) => x.product.code === code)
      .map((x) => {
        let originalUnit = this.originalFutureShipLists.filter(
          (t) => t.code === code
        );
        //if (x.exceeds == false) {
        if (Number(originalUnit[0].quantity) > unitCount) {
          x.quantity = Number(originalUnit[0].quantity) - unitCount;
          x.cartStatus = 'Remaining to schedule';
          x.exceeds = false;
        } else if (Number(originalUnit[0].quantity) < unitCount) {
          x.quantity = unitCount - Number(originalUnit[0].quantity);
          x.cartStatus = 'Exceeds';
          x.exceeds = true;
        } else if (Number(originalUnit[0].quantity) === unitCount) {
          x.quantity = unitCount;
          x.cartStatus = 'Scheduled';
          x.exceeds = false;
        }
        return x;
      });
    let allProdUnits = 0,
      allProdDoses = 0,
      allTotalUnitDoses = 0;
    this.originalFutureShipLists.forEach((ele) => {
      let totalQty = 0,
        totalDoses = 0,
        allTotalQty = 0;
      this.quantityList
        .filter((x) => x.hasOwnProperty(ele.code))
        .forEach((element, val) => {
          for (let val in element) {
            element[val].forEach((obj) => {
              for (let val in obj) {
                if (val.includes(type)) totalQty += Number(obj[val]);
                allTotalQty += Number(obj[val]);
              }
            });
          }
        });
      allProdUnits += totalQty;
      totalDoses = Number(totalQty) * Number(ele.quantityPerUnit);
      allProdDoses += totalDoses;
      let calDoses = Number(allTotalQty) * Number(ele.quantityPerUnit);
      allTotalUnitDoses += calDoses;
    });

    const totalUnitElement = document.getElementById(
      `${type}` + `Unit`
    ) as HTMLInputElement;
    const totalDosesElement = document.getElementById(
      `${type}` + `Doses`
    ) as HTMLInputElement;
    totalUnitElement.textContent = allProdUnits.toString();
    totalDosesElement.textContent = allProdDoses.toString();
    if (type != 'shipImmediate') {
      if (weekItem.hasOwnProperty(code)) delete weekItem[code];
      weekItem[code] = inputElement.value == '' ? '0' : inputElement.value;
      const doseElement = document.getElementById(
        `${type}` + `${code}` + 'doses'
      ) as HTMLDivElement;
      const product = this.originalFutureShipLists.find((x) => x.code === code);
      doseElement.textContent =
        Number(inputElement.value) > 0
          ? Number(inputElement.value) * Number(product.quantityPerUnit) +
            ' Doses'
          : '';
      weekItem['totalunit'] = allProdUnits.toString();
      weekItem['totalDoses'] = allProdDoses.toString();
    } else if (type == 'shipImmediate') {
      if (this.shipImmediateValue[code]) delete this.shipImmediateValue[code];
      this.shipImmediateValue[code] =
        inputElement.value == '' ? '0' : inputElement.value;
      const doseElement = document.getElementById(
        `shipImmediatedoses${code}`
      ) as HTMLDivElement;
      const product = this.originalFutureShipLists.find((x) => x.code === code);
      doseElement.textContent =
        Number(inputElement.value) > 0
          ? Number(inputElement.value) * Number(product.quantityPerUnit) +
            ' Doses'
          : '';
    }

    if (Number(this.originalDosesVal) < allTotalUnitDoses) {
      this.totalFutureDoses =
        Number(allTotalUnitDoses) - Number(this.originalDosesVal);
    } else if (Number(this.originalUnitsVal) > sumOfUnit) {
      this.totalFutureDoses =
        Number(this.originalDosesVal) - Number(allTotalUnitDoses);
    } else {
      this.totalFutureUnits = Number(this.originalDosesVal);
    }
  }

  onValueChange(event, popover) {
    this.tempDeliveryDate = moment(event).format('MM/DD/YYYY');
  }

  onShowOrHideHours(popover) {
    this.isShowDeliveryHours = !this.isShowDeliveryHours;
  }

  onContinue(confirmModal, deliveryDateModal) {
    if (
      this.schedulerStatus === 'Remaining to schedule' ||
      this.schedulerStatus === 'Exceeds Total'
    ) {
      this.modalService.open(confirmModal, {
        windowClass: `scheduler-confirm-modal ${this.baseSiteId}`,
      });
    } else {
      this.productList.length > 0
        ? this.onConfirmContinue(deliveryDateModal)
        : this.onDeliveryDateSubmit();
    }
  }

  navigateCart() {
    this.route.goByUrl('/cart');
  }

  onChangeWeek(event, weekItem) {
    if (weekItem.hasOwnProperty('selectedWeek'))
      delete weekItem['selectedWeek'];
    weekItem['selectedWeek'] = event.value;
  }

  validateInput(event) {
    if (event.keyCode === 69) {
      return false;
    } else {
      var reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
      return new RegExp(reg).test(event.key);
    }
  }

  getWeeks(index) {
    return this.weekList[index];
  }

  onFocusout(type, code) {
    const inputElement = document.getElementById(
      `${type}` + `${code}`
    ) as HTMLInputElement;
    if (inputElement.value == '') inputElement.value = '0';
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onConfirmContinue(modal) {
    this.closeModal();
    if (this.productList.length > 0) {
      this.modalService.open(modal, {
        windowClass: `delivery-modal ${this.baseSiteId}`,
      });
    } else {
      this.onDeliveryDateSubmit();
    }
  }

  onDeliveryDateSubmit() {
    let deliveryDatesArray = [],
      isError = false;
    let shipDateCurr = '';
    let shipDateForNonFS = '';
    if (this.shippingInfo != undefined) {
      let deliDateTemp = moment(this.deliveryDate).format('YYYY-MM-DD');
      let prodDeliDateTemp;
      let stdProductList = this.productList.filter(
        (x) => x.cartType == 'STANDARD'
      );
      if (this.productList.length > 0 && stdProductList.length > 0) {
        prodDeliDateTemp = moment(this.productDeliveryDate).format(
          'YYYY-MM-DD'
        );
      }
      this.shippingInfo.forEach((shipData, index) => {
        let formatDate = moment(shipData?.deliveryDate).format('YYYY-MM-DD');
        if (deliDateTemp === formatDate) {
          shipDateCurr = shipData?.shippingDate;
          shipDateCurr = moment(shipDateCurr).format('YYYY-MM-DD');
          shipData['updatedShipDate'] = shipDateCurr;
        }
        if (prodDeliDateTemp != undefined && prodDeliDateTemp != '') {
          if (prodDeliDateTemp === formatDate) {
            shipDateForNonFS = shipData?.shippingDate;
            shipDateForNonFS = moment(shipDateForNonFS).format('YYYY-MM-DD');
            shipData['updatedShipDate'] = shipDateForNonFS;
          }
        }
        if (prodDeliDateTemp !== undefined && prodDeliDateTemp !== '') {
          if (deliDateTemp <= prodDeliDateTemp) {
            if (deliDateTemp === formatDate) {
              this.headerDeliveryDate = deliDateTemp;
              this.headerShipDate = moment(shipData?.shippingDate).format(
                'YYYY-MM-DD'
              );
            }
          } else {
            if (prodDeliDateTemp === formatDate) {
              this.headerDeliveryDate = prodDeliDateTemp;
              this.headerShipDate = moment(shipData?.shippingDate).format(
                'YYYY-MM-DD'
              );
            }
          }
        } else {
          if (deliDateTemp === formatDate) {
            this.headerDeliveryDate = deliDateTemp;
            this.headerShipDate = moment(shipData?.shippingDate).format(
              'YYYY-MM-DD'
            );
          }
        }
      });
    }
    this.futureshipProdLists.forEach((cart, index) => {
      let deliveryObj = {};
      deliveryObj['childCartId'] = cart.childCartId;
      deliveryObj['deliveryDate'] = this.headerDeliveryDate;
      deliveryObj['shippingDate'] = this.headerShipDate;
      let splitdeliveryArray = [],
        noOfQuantity = 0;
      let tempArray = this.weekList.filter(
        (obj) =>
          obj.hasOwnProperty(cart.product.code) &&
          Number(obj[cart.product.code]) > 0
      );
      tempArray.forEach((obj) => {
        if (obj['selectedWeek'] === undefined) {
          this.globalMessage.add(
            'Please select the week of delivery',
            GlobalMessageType.MSG_TYPE_ERROR,
            50000
          );
          isError = true;
          window.scroll(0, 0);
          return;
        } else {
          splitdeliveryArray.push({
            splitQuantity: obj[cart.product.code],
            splitdeliveryDate: moment(obj['selectedWeek'])
              .add(2, 'd')
              .format('YYYY-MM-DD'),
          });
          noOfQuantity += +obj[cart.product.code];
        }
      });
      let shipDate2 = '';
      if (
        this.shipImmediateValue.hasOwnProperty(cart.product.code) &&
        Number(this.shipImmediateValue[cart.product.code]) > 0
      ) {
        let currentDate = '';

        if (!this.shipImmediateValue.hasOwnProperty('selectedWeek'))
          currentDate = moment().format('YYYY-MM-DD');
        this.shippingInfo.forEach((data1) => {
          if (
            this.shipImmediateValue['selectedWeek'] ===
              moment(data1?.deliveryDate).format('YYYY-MM-DD') ||
            moment(new Date(this.deliveryDate)).format('YYYY-MM-DD') ===
              moment(data1?.deliveryDate).format('YYYY-MM-DD')
          ) {
            shipDate2 = data1?.updatedShipDate;
          }
        });
        splitdeliveryArray.push({
          splitQuantity: this.shipImmediateValue[cart.product.code],
          splitdeliveryDate:
            currentDate == ''
              ? this.shipImmediateValue['selectedWeek']
              : moment(new Date(this.deliveryDate)).format('YYYY-MM-DD'),
          splitShippingDate: shipDate2 ? shipDate2 : '',
        });
        noOfQuantity += +this.shipImmediateValue[cart.product.code];
      }
      let shipDate3 = '';
      this.shippingInfo.forEach((data3) => {
        if (
          this.shipImmediateValue['selectedWeek'] ===
            moment(data3?.deliveryDate).format('YYYY-MM-DD') ||
          moment(new Date(this.deliveryDate)).format('YYYY-MM-DD') ===
            moment(data3?.deliveryDate).format('YYYY-MM-DD')
        ) {
          shipDate3 = data3?.updatedShipDate;
        }
        //adding ship immediate date to local storage
        localStorage.setItem(
          'shipImmediateDateFS',
          shipDate3 ? moment.utc(new Date(shipDate3)).format('YYYY-MM-DD') : ''
        );
        deliveryObj['entryDeliveryDates'] = [
          {
            entryNumber: cart.entryNumber,
            splitEntryDeliveryDate: splitdeliveryArray,
            splitShippingDate: shipDate3 ? shipDate3 : '',
          },
        ];
      });
      deliveryDatesArray.push(deliveryObj);
      this.updateCart(
        this.parentCartId,
        cart.childCartId,
        cart.entryNumber,
        noOfQuantity
      );
    });
    if (this.productList.length > 0) {
      let shipDate1 = '';
      const stdProdList = this.productList.filter(
        (x) => x.cartType == 'STANDARD'
      );
      stdProdList[0]?.entries.forEach((item, index) => {
        this.shippingInfo.forEach((data) => {
          if (
            moment(this.productDeliveryDate).format('YYYY-MM-DD') ===
            moment(data?.deliveryDate).format('YYYY-MM-DD')
          ) {
            shipDate1 = data?.updatedShipDate;
          }
        });
        deliveryDatesArray[0]['entryDeliveryDates'].push({
          entryNumber: item.entryNumber,
          deliveryDate: moment(this.productDeliveryDate).format('YYYY-MM-DD'),
          shippingDate: shipDate1 ? shipDate1 : '',
        });
      });

      const fluProdList = this.productList.filter(
        (x) => x.cartType == 'INFLUENZA'
      );
      if (fluProdList.length > 0) {
        let shipDate1 = '';
        let fluDataObj = {};
        fluDataObj['childCartId'] = fluProdList[0].cartId;
        fluDataObj['deliveryDate'] = moment(this.fluDeliveryDate).format(
          'YYYY-MM-DD'
        );
        fluDataObj['entryDeliveryDates'] = [];
        fluProdList[0].entries.forEach((item, index) => {
          this.fluShippingInfo.forEach((data) => {
            if (
              moment(this.fluDeliveryDate).format('YYYY-MM-DD') ===
              moment(data?.deliveryDate).format('YYYY-MM-DD')
            ) {
              shipDate1 = moment(data?.shippingDate).format('YYYY-MM-DD');
            }
          });
          fluDataObj['entryDeliveryDates'].push({
            entryNumber: item.entryNumber,
            deliveryDate: moment(this.fluDeliveryDate).format('YYYY-MM-DD'),
            shippingDate: shipDate1 ? shipDate1 : '',
          });
        });
        fluDataObj['shippingDate'] = shipDate1;
        deliveryDatesArray.push(fluDataObj);
      }
    }
    if (!isError) {
      this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
      const params = {
        b2bUnitId: this.b2bUnitId,
        deliveryDates: deliveryDatesArray,
      };
      this.quantityUpdateArray.forEach((item) => {
        this.addToCart.updateCartDetails(
          item.childCartId,
          item.entity,
          item.cartId
        );
      });
      this.addToCart.checkoutCartPage(params, this.parentCartId);
      this.checkoutCartDetailsSub =
        //this.addToCart.checkoutCartDetails$.subscribe((res) => {
        this.addToCart.checkoutCartDetails$
          .pipe(
            filter((res) => res),
            take(1)
          )
          .subscribe((res) => {
            if (res?.carts[0].hasOwnProperty('childCarts')) {
              this.modalService.dismissAll();
              this.route.goByUrl('/checkout');
              this.addToCart.weekList = [];
              this.addToCart.weekList = this.weekList;
              this.addToCart.shipImmediateValue = this.shipImmediateValue;
              this.addToCart.shippingDeliveryDate = this.deliveryDate;
              this.addToCart.productDeliveryDate = this.productDeliveryDate;
            } else {
              this.globalMessage.add(
                res?.carts[0]?.checkoutMessage,
                GlobalMessageType.MSG_TYPE_ERROR,
                5000000
              );
            }
          });
    } else {
      this.modalService.dismissAll();
    }
  }

  closePopup(popover) {
    this.isPopoverClosed = true;
    popover.close();
  }

  updateDeliveryDate(isShipImmDate, popover) {
    if (isShipImmDate === true || isShipImmDate === false) {
      isShipImmDate == true
        ? (this.deliveryDate = this.tempDeliveryDate)
        : (this.productDeliveryDate = this.tempDeliveryDate);
    } else if (isShipImmDate === 'flu') {
      this.fluDeliveryDate = this.tempDeliveryDate;
    }
    if (isShipImmDate === true) {
      if (this.shipImmediateValue.hasOwnProperty('selectedWeek'))
        delete this.shipImmediateValue['selectedWeek'];
      this.shipImmediateValue['selectedWeek'] = moment(
        new Date(this.tempDeliveryDate)
      ).format('YYYY-MM-DD');
    }
    this.closePopup(popover);
  }

  showOrHideUnit(index) {
    this.weekList[index]['showUnit'] = !this.weekList[index]['showUnit'];
  }

  getDateInRequiredFormat(dateString) {
    const utcDateTime = moment.utc(dateString);
    const localDateTime = utcDateTime.local();
    return localDateTime.toDate();
  }

  getDisabledDates(
    excludeDates: Array<Date>,
    minDate: Date,
    maxDate: Date,
    cartType
  ) {
    if (cartType === 'STANDARD') this.disabledDates = [];
    else if (cartType === 'INFLUENZA') this.fluDisabledDates = [];
    const millisecondPerDay = 24 * 60 * 60 * 1000;
    do {
      let found = false;
      for (let i = 0; i < excludeDates.length; i++) {
        let excludeDate: Date = excludeDates[i];
        if (this.isSameDay(excludeDate, minDate)) {
          found = true;
        }
      }
      if (!found) {
        this.disabledDates.push(minDate);
        if (cartType === 'STANDARD') {
          this.productList
            .filter((c) => c.cartType === 'STANDARD')
            .map((x) => {
              x['disabledDates'].push(minDate);
            });
        } else if (cartType === 'INFLUENZA') {
          this.fluDisabledDates.push(minDate);
          this.productList
            .filter((c) => c.cartType === 'INFLUENZA')
            .map((x) => {
              x['disabledDates'].push(minDate);
            });
        }
      }
      minDate = new Date(minDate.getTime() + millisecondPerDay);
    } while (minDate <= maxDate);
  }

  isSameDay(date1: Date, date2: Date) {
    if (
      date1.getFullYear() == date2.getFullYear() &&
      date1.getMonth() == date2.getMonth() &&
      date1.getDate() == date2.getDate()
    ) {
      return true;
    } else {
      return false;
    }
  }

  navigateProfile() {
    this.route.goByUrl('/my-account/profile');
  }

  getImage(product: any) {
    let tempImg;
    if (product?.images && product['images'].length > 0) {
      const imagesFormat = _.clone(
        _.findWhere(product['images'], { format: 'thumbnail' })
      );
      if (imagesFormat) {
        imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
      }
      tempImg = imagesFormat.url;
    } else {
      if (this.baseSiteId == 'vsh') {
        tempImg = '../../assets/i18n-assets/sanofi_missing_product.jpg';
      } else {
        tempImg = '../../assets/i18n-assets/sanofi_missing_product_vax.jpg';
      }
    }
    return tempImg;
  }

  exportExcel() {
    let j = 0;
    this.weekList.forEach((ele, index) => {
      if (index == 0) {
        j = 6;
      } else {
        j = j + 2;
      }
      let totalUnit = this.weekList[index].hasOwnProperty('totalunit')
        ? this.weekList[index]['totalunit']
        : 0;
      if (Number(totalUnit) > 0)
        this.exportExcelData[j][1] =
          totalUnit + `/` + this.weekList[index]['totalDoses'];
    });
    this.addToCart.downloadXls(this.exportExcelData, 'ScheduleFutureShipData');
  }

  addValuesToExcelData() {
    this.exportExcelData.splice(0, 0, ['Customer', this.b2bUnitId]);
    this.exportExcelData.splice(1, 0, ['', 'Requested Quantity']);
    this.exportExcelData.splice(2, 0, [
      'Material',
      this.originalFutureShipLists[0].code,
    ]);
    this.exportExcelData.splice(3, 0, [
      'Total Units/Doses',
      this.totalFutureUnits + '/' + this.totalFutureDoses,
    ]);
    this.exportExcelData.splice(4, 0, ['', '']);
  }

  ngOnDestroy() {
    this.futureshipProdLists = [];
    this.quantityList = [];
    this.exportExcelData = [];
    this.totalFutureDoses = '';
    this.totalFutureUnits = '';
    this.schedulerStatus = 'Remaining to schedule';
    this.cartIdSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.cartCheckSub?.unsubscribe();
    window.removeEventListener('resize',this.reSizeEvent, true);

  }

  openProductDetails(productDetails) {
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: `product-details-modal ${this.baseSiteId}`,
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = '';
    modalRef.componentInstance.unitSection = 'NoUnits';
  }

  openImage(content) {
    this.modalService.open(content, {
      windowClass: 'carousel-modal',
    });
  }

  updateCart(cartId, childCartId, entryNumber, noOfQuantity) {
    let params = {
      cartId: cartId,
      childCartId: childCartId,
      entity: [
        {
          entryNumber: entryNumber,
          quantity: +noOfQuantity,
          contractInfo: {
            contractId: '',
            contractDesc: '',
            contractPrice: {
              value: 0,
            },
          },
        },
      ],
    };
    this.quantityUpdateArray.push(params);
  }

  updateExistingUnit() {
    if (
      this.addToCart.weekList.length > 0 &&
      this.futureshipProdLists.length > 0
    ) {
      let isUpdated = false;
      this.addToCart.weekList.forEach((item, index) => {
        for (const key in item) {
          let isFound = this.futureshipProdLists.find(
            (x) => x.product.code === key
          );
          if (isFound) {
            //input
            const inputElement = document.getElementById(
              `${item.month + item.year}` + `${key}`
            ) as HTMLInputElement;
            if (inputElement) {
              inputElement.value = item[key];
              if (this.weekList[index].hasOwnProperty('selectedWeek'))
                delete this.weekList[index]['selectedWeek'];
              this.weekList[index]['selectedWeek'] = item.selectedWeek;
              this.weekList[index][key] = item[key];

              this.weekObj[index] = item.selectedWeek;
              this.performQuantityComputation(
                item.month + item.year,
                key,
                0,
                item
              );

              if (this.addToCart.weekList.length - 1 === index)
                isUpdated = true;
            }
          }
        }
      });
      if (isUpdated) {
        this.addToCart.weekList = [];
      }
    }
    if (
      Object.keys(this.addToCart.shipImmediateValue).length > 0 &&
      this.futureshipProdLists.length > 0
    ) {
      let isShipUpdated = false;
      for (const key in this.addToCart.shipImmediateValue) {
        let isFound = this.futureshipProdLists.find(
          (x) => x.product.code === key
        );
        if (isFound) {
          const inputElement = document.getElementById(
            `shipImmediate` + `${key}`
          ) as HTMLInputElement;
          if (inputElement) {
            inputElement.value = this.addToCart.shipImmediateValue[key];
            this.performQuantityComputation('shipImmediate', key, 0, '');
          }
          isShipUpdated = true;
        }
      }
      if (isShipUpdated) {
        this.shipImmediateValue = this.addToCart.shipImmediateValue;
        this.addToCart.shipImmediateValue = {};
      }
      if (this.addToCart.shippingDeliveryDate)
        this.deliveryDate = moment(this.addToCart.shippingDeliveryDate).format(
          'MM/DD/YYYY'
        );
      this.cd.detectChanges();
    }
    if (this.addToCart.productDeliveryDate) {
      this.productDeliveryDate = moment(
        this.addToCart.productDeliveryDate
      ).format('MM/DD/YYYY');
      this.cd.detectChanges();
    }
  }

  onChange(event, item) {
    item.product.selectedContract = event?.contractId;
    const inputElement = document.getElementById(
      `${'price' + item.product.code}`
    ) as HTMLInputElement;
    inputElement.innerHTML = event.contractPrice?.formattedValue;
  }

  getContractPrice(productEntry) {
    let price = '$--';
    const localContractId = productEntry?.product?.selectedContract;
    productEntry?.product?.conditions.map((condition) => {
      if (condition.contractId == localContractId) {
        price = condition?.contractPrice?.value;
      }
    });
    return price;
  }

  setMinMaxDeliveryDate(childCart, cartType) {
    const deliveryDatesArray = childCart?.deliveryDates;
    if (deliveryDatesArray) {
      const minDate = this.getDateInRequiredFormat(deliveryDatesArray[0]);
      const maxDate = this.getDateInRequiredFormat(
        new Date(deliveryDatesArray[deliveryDatesArray?.length - 1])
      );
      this.minDate = minDate;
      this.maxDate = maxDate;
      this.shippingInfo = childCart?.shippingInfos;
      this.deliveryDate = moment(minDate).format('MM/DD/YYYY');
      if (cartType === 'STANDARD') {
        this.productDeliveryDate = moment(minDate).format('MM/DD/YYYY');
        this.productList
          .filter((c) => c.cartType === 'STANDARD')
          .map((x) => {
            x['minDate'] = minDate;
            x['maxDate'] = maxDate;
            x['disabledDates'] = [];
          });
      } else if (cartType === 'INFLUENZA') {
        this.fluDeliveryDate = moment(minDate).format('MM/DD/YYYY');
        this.fluShippingInfo = childCart?.shippingInfos;
        this.productList
          .filter((c) => c.cartType === 'INFLUENZA')
          .map((x) => {
            x['minDate'] = minDate;
            x['maxDate'] = maxDate;
            x['disabledDates'] = [];
          });
      }
      let enabledDates = [];
      deliveryDatesArray?.forEach((d) => {
        enabledDates.push(this.getDateInRequiredFormat(new Date(d)));
      });
      this.getDisabledDates(enabledDates, minDate, maxDate, cartType);
    }
  }

  setProductDeliveryDate(cartType) {
    return cartType == 'STANDARD'
      ? this.productDeliveryDate
      : this.fluDeliveryDate;
  }
}
